<template>
  <v-app>
    <app-navigation
      :layout="layout"
      :authReady="authReady"
      :fetchInitialPending="fetchInitialPending"
    />
    <app-header
      :layout="layout"
      :authReady="authReady"
    />
    <v-main>
      <v-alert
        v-if="false"
        :value="maintenanceActive"
        color="warning"
        class="mt-0 d-flex justify-center"
        style="z-index: 8;"
        :class="isHome || isHowItWorksPage ? 'absoluteAlerts' : ''"
      >
        {{ $t('texts.maintenanceText') }}
      </v-alert>
      <v-alert
        v-if="false"
        :value="true"
        color="warning"
        class="mt-0 py-2 d-flex justify-center"
        style="z-index: 8;"
        :class="isHome || isHowItWorksPage ? 'absoluteAlerts' : ''"
      >
        <v-btn
          class="ma-0"
          outlined
          @click="showCoronaDialog()"
        >
          {{ $t('texts.corona.alertText' )}}
        </v-btn>
      </v-alert>
      <v-container>
        <v-row>
          <v-col :cols="12" :class="$vuetify.breakpoint.xsOnly ? 'mb-5' : ''">
            <router-view/>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <app-footer
      :authReady="authReady"
    />
    <dialogs/>
    <snackbar/>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import AppNavigation from './components/_organisms/layout/AppNavigation.vue';
import AppHeader from './components/_organisms/layout/AppHeader.vue';
import AppFooter from './components/_organisms/layout/AppFooter.vue';
import Dialogs from './components/_organisms/layout/Dialogs.vue';
import Snackbar from './components/_molecules/Snackbar.vue';

const { mapState: mapUserState } = createNamespacedHelpers('user');
const { mapState: mapCompanyState } = createNamespacedHelpers('company');

export default {
  name: 'app',
  components: {
    AppNavigation,
    AppHeader,
    AppFooter,
    Dialogs,
    Snackbar,
  },
  data() {
    return {
      layout: {
        drawer: false,
      },
      coronaDialog: {
        open: false,
      },
    };
  },
  computed: {
    authReady() {
      return this.$auth.check();
    },
    ...mapUserState([
      'maintenanceActive',
      'predefinedSeason',
      'authUser',
    ]),
    ...mapCompanyState([
      'fetchInitialPending',
    ]),
    isHome() {
      return this.$route.name === 'home' || this.$route.name === null;
    },
    isHowItWorksPage() {
      return this.$route.name === 'page.how-it-works' || this.$route.name === 'page.job-advertisement' || this.$route.name === 'page.find-a-job';
    },
    route() {
      return this.$route;
    },
  },
  methods: {
    showCoronaDialog() {
      this.$eventBus.$emit('show-corona-dialog');
    },
  },
  watch: {
    route() {
      this.layout.drawer = false;
    },
  },
};
</script>

<style lang="scss">
  @import './scss/styles.scss';

  .absoluteAlerts {
    position: absolute;
    width: 100%;
  }
</style>
